import { render } from "./OrderSummary.vue?vue&type=template&id=47287273"
import script from "./OrderSummary.vue?vue&type=script&lang=js"
export * from "./OrderSummary.vue?vue&type=script&lang=js"
script.render = render

export default script